// 线索分配设置
export class LeadsDistriSettings {
  constructor(id, desc) {
    this.id = id;
    this.desc = desc;
  }

  getDesc() {
    return this.desc;
  }

  getId() {
    return this.id;
  }
}

LeadsDistriSettings.MANUAL = new LeadsDistriSettings('MANUAL', '人工手动分配');
LeadsDistriSettings.RULE_TOTAL_AVG = new LeadsDistriSettings('RULE_TOTAL_AVG', '按员工线索量平均分配');
LeadsDistriSettings.RULE_TAG_AVG = new LeadsDistriSettings('RULE_TAG_AVG', '按员工【未跟进】线索量补充分配');
LeadsDistriSettings.RULE_ASSIGNED_IN_ORDER = new LeadsDistriSettings('RULE_ASSIGNED_IN_ORDER', '按员工顺序循环分配');

Object.freeze(LeadsDistriSettings);

// 线索通知设置
export class SmsNotification {
  constructor(id, desc) {
    this.id = id;
    this.desc = desc;
  }

  getDesc() {
    return this.desc;
  }

  getId() {
    return this.id;
  }
}

SmsNotification.SMS_NOTIFICATION_OFF = new SmsNotification('SMS_NOTIFICATION_OFF', '短信通知关闭');
SmsNotification.SMS_NOTIFICATION_ON = new SmsNotification('SMS_NOTIFICATION_ON', '短信通知开启');

Object.freeze(SmsNotification);
